import { Heading, HeadingProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import '../../../fonts.css';

export function SectionTitle({ children, ...props }: PropsWithChildren & HeadingProps) {
  return (
    <Heading color={ props.color ? props.color : "#787878"} fontSize={'12pt'} {...props}>
      {children}
    </Heading>
  );
}
